import { render, staticRenderFns } from "./ManifestKlaimPp.vue?vue&type=template&id=e0a1ec30&scoped=true&"
import script from "./ManifestKlaimPp.vue?vue&type=script&lang=js&"
export * from "./ManifestKlaimPp.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKlaimPp.vue?vue&type=style&index=0&id=e0a1ec30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a1ec30",
  null
  
)

export default component.exports